import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import typography from "assets/theme/base/typography";

function Footer({ light }) {
  const { size } = typography;

  return <MDBox position="absolute" width="100%" bottom={0} py={4}></MDBox>;
}
Footer.defaultProps = {
  light: false,
};
Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
